
import {Component, Vue} from 'vue-property-decorator';
import {dictApi} from "@/api/organization";
import {baseUrl} from "@/constants";

@Component({})
export default class Home extends Vue {
  active = 0;
  baseUrl = baseUrl;
  form = {
    types : [] as Array<string>,
    docType :''
  }
  screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
  mechanismTypeList = [];
  rules = {
    types: [{required: true, message: "请选择单位类别", trigger: "blur"}],
    docType: [{required: true, message: "请选择证件类型", trigger: "blur"}],
  }
  mechanismData = {
    userName: '',
    name: '',
    clientName: '',
    idCard: ''
  }
  created() {
    //单位类别
    dictApi.listDictItem({typeCode: "dwlb"}).then((r) => {
      if (r.data.result === 0) {
        this.mechanismTypeList = r.data.data;
      }
    });
  }

  prevStep(){
    this.active--;
  }
  nextStep() {
    this.active++;
  }
  isDisable(val: string) {
    if(['0001', '0002', '0006'].indexOf(val) > -1){
      return true;
    }
    return false;
  }

  logout() {
      this.$router.replace("/login");
  }
  goRegisterCompany() {
    let form = this.$refs.form as HTMLFormElement;
    form.validate((valid: any) => {
      if (valid) {
        if (this.form.docType === 'QTLX') {
          this.$router.replace("/register-company?types=" + this.form.types.join(","));
        } else {
          this.$router.replace("/register-company-v2?types=" + this.form.types.join(",") + "&docType=" + this.form.docType);
        }
      }
    });
  }

  changeType() {
    if (this.form.types.indexOf("0008") > -1 || this.form.types.indexOf("0002") > -1) {
      this.form.docType = "QTLX";
    } else if (this.form.types.indexOf("0001") > -1) {
      this.form.docType = "FRZS";
    } else {
      this.form.docType = "YYZZ";
    }
  }

  download() {
    window.open(baseUrl + `/file/download-empower?legal=${this.mechanismData.userName}&orgName=${this.mechanismData.name}&agent=${this.mechanismData.clientName}&idCard=${this.mechanismData.idCard}`, '_blank');
  }
}
